import React, { useState } from "react";
import { Braces, MessageSquarePlus } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/Dialog";
import DeveloperToolsContent from "./DeveloperToolsContent";
import FeedbackForm from "./FeedbackForm";

const floatingActionClass =
  "flex items-center gap-2 rounded-full border border-gray-300 bg-white text-gray-800 shadow-md pl-1 pr-3 py-1 hover:bg-purple-50 hover:border-ktx-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ktx-purple transition-colors";

const floatingActionIconClass =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-gray-700 group-hover:text-ktx-purple transition-colors";

const FloatingAction = ({ label, onClick, children }) => (
  <button
    type="button"
    className={`group ${floatingActionClass}`}
    onClick={onClick}
    aria-label={label}
    title={label}
  >
    <span className={floatingActionIconClass}>{children}</span>
    <span className="text-sm font-medium pr-0.5">{label}</span>
  </button>
);

const SupportFloatingActions = ({ patientId, trace, traceLoading, traceError }) => {
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <>
      <div
        className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end pointer-events-none"
        aria-label="Page actions"
      >
        <div className="flex flex-col gap-3 pointer-events-auto">
          <FloatingAction label="Feedback" onClick={() => setFeedbackOpen(true)}>
            <MessageSquarePlus className="h-5 w-5" aria-hidden />
          </FloatingAction>
          <FloatingAction label="Developer tools" onClick={() => setDevToolsOpen(true)}>
            <Braces className="h-5 w-5" aria-hidden />
          </FloatingAction>
        </div>
      </div>

      <Dialog open={devToolsOpen} onOpenChange={setDevToolsOpen}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Developer tools</DialogTitle>
            <DialogDescription>
              Raw trace JSON for debugging. Not part of the patient record review.
            </DialogDescription>
          </DialogHeader>
          <DeveloperToolsContent
            patientId={patientId}
            trace={trace}
            traceLoading={traceLoading}
            traceError={traceError}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={feedbackOpen} onOpenChange={setFeedbackOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Feedback</DialogTitle>
            <DialogDescription>
              Share a bug report or feature request for this dashboard.
            </DialogDescription>
          </DialogHeader>
          <FeedbackForm patientId={patientId} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SupportFloatingActions;
